module.exports = __webpack_public_path__ + "static/img/weihu.2024f87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/weihu.png
// module id = YLdl
// module chunks = 15